
namespace TabAurous.ECommerce {

    @Serenity.Decorators.registerClass()
    export class ECommSalesReportGrid extends Serenity.EntityGrid<ECommSalesReportRow, any> {
        protected getColumnsKey() { return 'ECommerce.ECommSalesReport'; }
        protected getDialogType() { return ECommSalesReportDialog; }
        protected getIdProperty() { return ECommSalesReportRow.idProperty; }
        protected getInsertPermission() { return ECommSalesReportRow.insertPermission; }
        protected getLocalTextPrefix() { return ECommSalesReportRow.localTextPrefix; }
        protected getService() { return ECommSalesReportService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
            this.setTitle("");
            this.addDateRangeFilter("TransDate", "Date");
        }
        protected createQuickSearchInput() { }
        protected getButtons(): Serenity.ToolButton[] {
            super.getButtons();

            return [/*({
                title: 'Print Register',
                cssClass: 'export-pdf-button',
                //icon: 'fa-cloud-download',
                onClick: () => {

                    Common.ReportHelper.execute({
                        reportKey: '',
                        params: {
                            CompanyIds: this.view.params.CompanyIds,
                            FinIds: this.view.params.FinancialYearIds,
                            VendorIds: this.view.params.VendorIds,
                            date: this.view.params.Criteria
                        }
                    });
                }
            }
            )*/]
        }
        protected usePager(){ return false; }


    }
    @Serenity.Decorators.registerClass()
    export class ECommSalesDayWiseGrid extends Serenity.EntityGrid<ECommSalesReportRow, any> {
        protected getColumnsKey() { return 'ECommerce.ECommSalesDayWise'; }
        protected getDialogType() { return ECommSalesReportDialog; }
        protected getIdProperty() { return ECommSalesReportRow.idProperty; }
        protected getInsertPermission() { return ECommSalesReportRow.insertPermission; }
        protected getLocalTextPrefix() { return ECommSalesReportRow.localTextPrefix; }
        protected getService() { return ECommSalesDayWiseService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
            this.addDateRangeFilter("TransDate", "Date");
            this.setTitle("");
        }
        protected createQuickSearchInput() { }
        protected getButtons(): Serenity.ToolButton[] {
            super.getButtons();

            return [/*({
                title: 'Print Register',
                cssClass: 'export-pdf-button',
                //icon: 'fa-cloud-download',
                onClick: () => {

                    Common.ReportHelper.execute({
                        reportKey: '',
                        params: {
                            CompanyIds: this.view.params.CompanyIds,
                            FinIds: this.view.params.FinancialYearIds,
                            VendorIds: this.view.params.VendorIds,
                            date: this.view.params.Criteria
                        }
                    });
                }
            }
            )*/]
        }
        protected usePager() { return false; }


    }

}